import { Link } from "react-router-dom";
import { FaArrowRight, FaCheckCircle } from "react-icons/fa";
import styles from "./Section4.module.css";
import Section5 from "../Section5/index";

const benefits = [
  "Increase Revenue",
  "Increase Efficiency",
  "Cut Costs",
  "Access Expertise",
  "Reduce Errors",
  "Improve Customer Service",
  "Focus on Care",
  "Stay Compliant",
];

export default function Section4() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.content}>
          <span className={styles.kicker}>Why Outsourcing Works</span>
          <h2>Benefits of Outsourcing RCM Services</h2>
          <p>
            Outsourcing Revenue Cycle Management (RCM) and{" "}
            <Link to={"/services/medical-billing"}>
              {" "}
              medical billing consulting
            </Link>{" "}
            improves billing accuracy, reduces claim denials, speeds up
            reimbursements, and enhances financial performance while allowing
            healthcare providers to focus on patient care.
          </p>

          <div className={styles.benefitGrid}>
            {benefits.map((benefit) => (
              <div key={benefit} className={styles.benefitItem}>
                <span>
                  <FaCheckCircle />
                </span>
                {benefit}
              </div>
            ))}
          </div>

          <Link to="/specialities" className={styles.ctaButton}>
            Visit Our Specialties
            <FaArrowRight />
          </Link>
        </div>

        <div className={styles.visualPanel}>
          <div className={styles.visualFrame}>
            <img
              src="./img/we-want-to-help.webp"
              alt="Healthcare team collaboration and revenue cycle support"
            />
          </div>
          <div className={styles.floatingCard}>
            <strong>RCM That Scales</strong>
            <p>
              Built to improve financial clarity, team efficiency, and
              operational confidence.
            </p>
          </div>
        </div>
      </div>
      <Section5 />
    </section>
  );
}
